export let ignore = "aB0n$c";
export default {ignore};